import { ShowProps } from './types';

export const Show = (props: ShowProps) => {
  const { when, children } = props;

  if (!when) {
    return null;
  }

  return children;
};
